import React from 'react'
import { ActivityIndicator } from 'react-native'
import { useTheme } from '../../theming/ThemeProvider'

const LoadIndicator = () => {
  const { theme } = useTheme()
  return (
    <ActivityIndicator
      color={theme.BUNKER}
      size='large'
    />
  )
}

export default LoadIndicator
